import { gql } from "@apollo/client";

export const GET_REMITOS_BOT = gql`
query GetRemitosBOT($filters: ReporteBOTFilterInput!){
  remitosBOT (filters: $filters){
    success,
    error,
    valorEsperado {
        idReporte
        tipo_Documento
        numero_Remito
        cantRemitos
        oficina_Venta
        cUIT_Cliente
        empresa
        egreso_ID
        origen
        docuemento
        estado
        fechaAlta
        nH
        fechaNH
        trackingRecepcion
        trackingEnvio              
        fechatracking
        accion
    }
  }            
}`;